import React from 'react'
import SetUpWagers from "./SetUpWagers";
import { useStateValue } from "./StateProvider";

function Wagers() {
    const [{ players }] = useStateValue();


    return (
        <div>
                  <div className="player__lineitems">
        {players?.map((player) => (
          <div>
            <SetUpWagers id={player.id} />
          </div>
        ))}
      </div>
        </div>
    )
}

export default Wagers
